/* eslint no-underscore-dangle: ["error", { "allow": ["__queryID", "__position"] }] */
import PropTypes from "prop-types";

import { useAlgoliaEvents } from "hooks";

const withAlgoliaTracking = (WrappedComponent) => {
  function WithAlgoliaTracking({ onClick, ...restProps }) {
    const { trackEventAfterSearch } = useAlgoliaEvents();

    const handleAlgoliaClick = (item) => {
      if (item.shouldTrackAlgoliaAnalytics === true) {
        trackEventAfterSearch(item);
      }

      if (onClick) {
        onClick(item);
      }
    };

    return <WrappedComponent {...restProps} onClick={handleAlgoliaClick} />;
  }

  WithAlgoliaTracking.propTypes = {
    onClick: PropTypes.func,
  };

  return WithAlgoliaTracking;
};

withAlgoliaTracking.propTypes = {
  WrappedComponent: PropTypes.elementType.isRequired,
  onClick: PropTypes.func,
};

export default withAlgoliaTracking;
